module.exports = __webpack_public_path__ + "h5/img/baokuan.6313c8c8.png";